import { InterconsultService } from "../../services/models/interconsult/interconsult";
const moduleIc = {
  namespaced: true,
  state: {
    ics: [],
    icsSent: [],
    loading: false,
    loadingSent: false,
    dataToFilter: {
      state: null,
      state2: null,
      has_pertinence: null,
      state_interconsult: null,
      step_state_interconsult: null,
      list: null,
    },
  },
  getters: {
    getIcs(state) {
      return state.ics;
    },
    getIcsSent(state) {
      return state.icsSent;
    },
    getLoading(state) {
      return state.loading;
    },
    getLoadingSent(state) {
      return state.loadingSent;
    },
  },
  mutations: {
    loadIcs(state, ics) {
      state.ics = ics;
    },
    loadIcsSent(state, ics) {
      state.icsSent = ics;
    },
    setDataToFilter(state, data) {
      state.dataToFilter = {
        ...state.dataToFilter,
        ...data,
      };
    },
    cleanDataToFilter(state) {
      state.dataToFilter = {
        state: null,
        state2: null,
        has_pertinence: null,
        state_interconsult: null,
        step_state_interconsult: null,
        list: null,
      };
    },
  },
  actions: {
    async loadIcsByDestination({ commit, state, rootGetters }, payload) {
      state.loading = true;
      console.log(state);
      let dataFilter = {
        patient_id: rootGetters["patient/getPatient"].id,
        ...state.dataToFilter,
      };
      if (localStorage.getItem("role_id") != 3) {
        dataFilter = { ...dataFilter, destination_node_id: window.localStorage.getItem("stablishment") };
      }
      let ics = await InterconsultService.getByDestinationFilter(dataFilter, payload?.page ? payload.page : 1);
      commit("loadIcs", ics);
      state.loading = false;
    },
    async loadIcsByOrigin({ commit, state, rootGetters }, payload) {
      state.loadingSent = true;
      console.log(state);
      let dataFilter = {
        patient_id: rootGetters["patient/getPatient"].id,
        ...state.dataToFilter,
      };
      if (localStorage.getItem("role_id") != 3) {
        dataFilter = { ...dataFilter, origin_node_id: window.localStorage.getItem("stablishment") };
      }
      let ics = await InterconsultService.getByOriginFilter(dataFilter, payload?.page ? payload.page : 1);
      commit("loadIcsSent", ics);
      state.loadingSent = false;
    },
  },
};

export default moduleIc;
